import React from 'react';

interface BoletoIconProps {
  className?: string;
}

const BoletoIcon: React.FC<BoletoIconProps> = ({ className = "w-6 h-6" }) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className={className}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M9 4.5v15m6-15v15m-10.5-15h.008v15h-.008v-15zm15 0h.008v15h-.008v-15zm-4.5 0h.008v15h-.008v-15zm-3 0h.008v15h-.008v-15z" />
  </svg>
);

export default BoletoIcon; 